export function transformRequestQueryParams(queryParams = {}, settings = {}) {
  if (settings.sort) {
    queryParams.sort = `${settings.sort.columnName}:${settings.sort.direction}`;
  }
  if (settings.paging) {
    if (settings.paging.offset) {
      queryParams.offset = settings.paging.offset;
    }
    if (settings.paging.limit) {
      queryParams.limit = settings.paging.limit;
    }
  }
  return queryParams;
}
